import React, { useEffect } from 'react';
import AppRoutes from './routes/AppRoutes';

import loginIllustration from './assets/login-illustration.svg';
import loginIllustration2 from './assets/login-illustration2.png';
import autopathIcon from './assets/autopath-icon.svg';

const preloadImages = (imageUrls: string[]) => {
  imageUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

const App: React.FC = () => {
  useEffect(() => {
    preloadImages([loginIllustration, loginIllustration2, autopathIcon]);
  }, []);

  // Prevent going back to /login after authentication
  useEffect(() => {
    const handlePopState = () => {
      const token = localStorage.getItem('autopath_access_token');

      if (token && window.location.pathname === '/login') {
        // Force push to dashboard if user tries to go back
        window.history.pushState(null, '', '/dashboard');
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return <AppRoutes />;
};

export default App;